// extracted by mini-css-extract-plugin
export var arrow = "_3j-6";
export var changeItem = "_3j-3";
export var changesHeader = "_3j-1";
export var changesList = "_3j-2";
export var container = "_3j-0";
export var pathLabel = "_3j-4";
export var value = "_3j-7";
export var valuesContainer = "_3j-5";